export const iconFontAwesomeLogisticsHelicopterSymbol = (
	<i className="fa-solid fa-helicopter-symbol"></i>
);
